import React from "react";

import useTranslations from "../../../../../hooks/useTranslations";
import UserAvatarGroup from "../../../../utils/UserAvatarGroup";

import { Box, Link } from "@chakra-ui/react";
import Tooltip from "@reach/tooltip";
import Linkify from "react-linkify";
import { UserMinimalFragment } from '../../../../../graphql/generated/definitions';

const linkDecorator = (href: string, text: string, key: string) => (
  <Link href={href} key={key} target="_blank" color="blue.500">
    {text}
  </Link>
);

type QuestionTitleProps = {
  displayIndex?: string;
  title: string;
  description?: string;
  required?: boolean;
  referents?: UserMinimalFragment[];
};

const QuestionTitle: React.FC<QuestionTitleProps> = ({
  title,
  description,
  displayIndex,
  required,
  referents = [],
}) => {
  const t = useTranslations();

  if (referents.length > 0) {
    return (
      <div className="flex flex-col space-y-2">
        <Tooltip
          label={
            referents.length > 0
              ? t("reports.evaluationAlsoDoneBy", {
                  referents: referents.map((r) => r.name).join(", "),
                })
              : t("reports.evaluationByYouAndHR")
          }
        >
          <div className="flex items-center justify-start text-base font-bold gap-x-2 text-secondary-700">
            <div>
              {displayIndex && (
                <span className="pr-2 text-base font-bold">
                  {displayIndex}.
                </span>
              )}
              {title}
              {required && (
                <span className="pl-2 text-base font-bold text-danger-600">
                  *
                </span>
              )}
            </div>
            <UserAvatarGroup users={referents} enableMenu={false} size={4} />
          </div>
        </Tooltip>

        {description && (
          <div className="flex flex-col space-y-1 text-sm text-light-900">
            <span>{t("reports.questionDescription")}</span>
            <Box whiteSpace="pre-line">
              <Linkify componentDecorator={linkDecorator}>
                {description}
              </Linkify>
            </Box>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col space-y-2">
      <div className="flex justify-between text-base font-bold text-secondary-700">
        <div>
          {displayIndex && (
            <span className="pr-2 text-base font-bold">{displayIndex}.</span>
          )}
          {title}
          {required && (
            <span className="pl-2 text-base font-bold text-danger-600">
              *
            </span>
          )}
        </div>
      </div>
      {description && (
        <div className="flex text-sm text-light-900">{description}</div>
      )}
    </div>
  );
};

export default React.memo(QuestionTitle);
